var map = {
	"./demos/basic/index.ts": 16929,
	"./demos/children/index.ts": 45610,
	"./demos/circle/index.ts": 98,
	"./demos/customColor/index.ts": 6353,
	"./demos/innerText/index.ts": 91684,
	"./demos/size/index.ts": 32422,
	"./demos/status/index.ts": 62143
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 14346;